module.exports = __webpack_public_path__ + "img/menu-fz.f2ac6ea2.png";